import React from "react";
import { Formik } from "formik";
import { Form } from "react-bootstrap";
import { PersonnelWizardNav } from "../../personnels/personnel-edit/PersonnelWizardNav";
import { TeacherGeneralInfoForm } from "./TeacherGeneralInfoForm";
import { PersonnelContactInfoForm } from "../../personnels/personnel-edit/PersonnelContactInfoForm";
import { PersonnelServiceInfoForm } from "../../personnels/personnel-edit/PersonnelServiceInfoForm";
import { PersonnelContractInfoForm } from "../../personnels/personnel-edit/PersonnelContractInfoForm";
import { PersonnelBankAccountInfoForm } from "../../personnels/personnel-edit/PersonnelBankAccountInfoForm";
import { PersonnelEducationalBackgroundInfoForm } from "../../personnels/personnel-edit/PersonnelEducationalBackgroundInfoForm";
import { PersonnelPartnerInfoForm } from "../../personnels/personnel-edit/PersonnelPartnerInfoForm";

export function TeacherEditForm({ 
  teacher,
  btnRef,
  saveTeacher
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={teacher}
      onSubmit={(values) => {
        const formData = new FormData();
        if (values.serviceYear === "") values.serviceYear = 0;
        if (values.workingYearInTheSchool === "") values.workingYearInTheSchool = 0;
        if (values.yearOfSeniority === "") values.yearOfSeniority = 0;
        if (values.contract.salary === "") values.contract.salary = null;
        if (values.contract.formalSalary === "") values.contract.formalSalary = null;
        if (values.graduate.graduationYear === "") values.graduate.graduationYear = null;
        if (values.postGraduate.graduationYear === "") values.postGraduate.graduationYear = null;
        if (values.doctorate.graduationYear === "") values.doctorate.graduationYear = null;                      
        formData.append("fileData", values.photoFile);
        formData.append("fileRemove", document.getElementsByName("teacher_photo_remove")[0].value);
        formData.append("serializedData", JSON.stringify(values));
        saveTeacher(formData);
      }}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          {/* <!--begin: Wizard --> */}
          <div          
            className="wizard wizard-4"
            id="teacher_form_wizard"
            data-wizard-state="step-first"
          >
            {/* <!--begin: Form Wizard Nav --> */}
            <PersonnelWizardNav />
            {/* <!--end: Form Wizard Nav --> */}          

            <div className="pt-lg-5">                
              {/* <!--begin: Form Wizard Form--> */}
              {/* <!--begin: Form Wizard Step 1--> */}
              <div
                data-wizard-type="step-content"
                data-wizard-state="current"
              >
                <h5 className="mb-10 font-weight-bold text-dark">
                  Genel Bilgiler
                </h5>
                <TeacherGeneralInfoForm
                  teacher={teacher}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  values={values}
                />

                <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                  İletişim Bilgileri
                </h5>            
                <PersonnelContactInfoForm
                  handleChange={handleChange}
                  values={values}
                />
                
                <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                  Hizmet Bilgileri
                </h5>            
                <PersonnelServiceInfoForm
                  handleChange={handleChange}
                  values={values}
                />
              </div>
              {/* <!--end: Form Wizard Step 1--> */}

              {/* <!--begin: Form Wizard Step 2--> */}
              <div data-wizard-type="step-content">
                <h5 className="mb-10 font-weight-bold text-dark">
                  Sözleşme Bilgileri
                </h5>
                <PersonnelContractInfoForm
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  values={values.contract}
                />

                <h5 className="mt-10 mb-10 font-weight-bold text-dark">
                  Banka Hesap Bilgileri
                </h5>
                <PersonnelBankAccountInfoForm
                  handleChange={handleChange}
                  values={values.contract}
                />
              </div>
              {/* <!--end: Form Wizard Step 2--> */}

              {/* <!--begin: Form Wizard Step 3--> */}
              <div data-wizard-type="step-content">
                <h5 className="mb-10 font-weight-bold text-dark">
                  Eğitim Bilgileri
                </h5>
                <PersonnelEducationalBackgroundInfoForm
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  values={values}
                />
              </div>
              {/* <!--end: Form Wizard Step 3--> */}       

              {/* <!--begin: Form Wizard Step 4--> */}      
              <div data-wizard-type="step-content">
                <h5 className="mb-10 font-weight-bold text-dark">
                  Eş Bilgileri
                </h5>
                <PersonnelPartnerInfoForm
                  partner={teacher.partner}
                  handleChange={handleChange}
                  values={values.partner}
                />     
              </div>
              {/* <!--end: Form Wizard Step 4--> */}
              {/* <!--end: Form Wizard Form--> */}
            </div>
          </div>          
          {/* <!--end: Wizard --> */}

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}